import { Component, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { TAlertType } from './alert.types';

@Component({
	selector: 'rbc-alert',
	templateUrl: './alert.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnDestroy {
	@Input() closable: boolean = true;
	@Input() header: string;
	@Input() id: string;
	@Input() transition: boolean = true;
	@Input() type: TAlertType = 'info';

	@Output() alertClosed = new EventEmitter();

	msg: string = 'default';
	visible: boolean = true;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	alert_close() {
		this.visible = false;
		// allow parent to know if the close button has been pressed
		this.alertClosed.emit('alert closed');
	}
}
